
// src/components/insights/CardHeader.tsx
import { Badge } from "@/components/ui/badge";
import { Link as LinkIcon } from "lucide-react";
import { Poll } from "@/types/poll";

interface CardHeaderProps {
  category: string;
  linkedPoll: string | null;
  statsStatus?: string | null;
  totalPollsters?: number;
  linkedPolls?: Poll[]; // New prop for actual poll data
}

const CardHeader = ({
  category,
  linkedPoll,
  statsStatus,
  totalPollsters,
  linkedPolls = [],
}: CardHeaderProps) => {
  // Function to generate poll status summary
  const generatePollStatusSummary = (polls: Poll[]) => {
    if (!polls || polls.length === 0) return null;
    
    const statusCounts = polls.reduce((acc, poll) => {
      const status = poll.status;
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {} as Record<string, number>);
    
    const statusLabels: Record<string, string> = {
      'live': 'Live',
      'closed': 'Closed',
      'draft': 'Draft'
    };
    
    const summaryParts = Object.entries(statusCounts).map(([status, count]) => {
      const label = statusLabels[status] || status;
      return `${count} ${label}`;
    });
    
    return summaryParts.join(', ');
  };

  const pollStatusSummary = generatePollStatusSummary(linkedPolls);

  return (
    <div className="flex justify-between items-start mb-3 gap-2 pr-20">
      <div className="flex items-center gap-2 flex-wrap min-w-0 flex-1">
        <Badge className="bg-nation-purple/20 text-nation-purple-dark dark:bg-nation-purple/10 dark:text-nation-purple hover:bg-nation-purple/30 dark:hover:bg-nation-purple/20 flex-shrink-0">
          {category}
        </Badge>
        {linkedPoll && (
          <Badge
            variant="outline"
            className="flex items-center gap-1 text-xs bg-nation-purple/20 text-nation-purple-dark hover:bg-nation-purple/30 flex-shrink-0"
          >
            <LinkIcon size={12} />
            {pollStatusSummary ? (
              <span className="text-blue-600 dark:text-blue-400 truncate">
                {pollStatusSummary}
              </span>
            ) : statsStatus === "active" ? (
              <span className="text-green-600 dark:text-green-400">
                Live Poll
              </span>
            ) : statsStatus === "completed" ? (
              <span className="text-blue-600 dark:text-blue-400">
                Completed Poll
              </span>
            ) : (
              <span className="text-gray-600 dark:text-gray-400">
                Pending Poll
              </span>
            )}
          </Badge>
        )}
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        {totalPollsters !== undefined && (
          <div className="text-sm text-gray-500 dark:text-gray-400 whitespace-nowrap">
            {totalPollsters} pollsters
          </div>
        )}
      </div>
    </div>
  );
};

export default CardHeader;
